import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import './PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  const [markdownContent, setMarkdownContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadMarkdownContent = async () => {
      try {
        const response = await fetch('/privacy-policy.md');
        if (!response.ok) {
          throw new Error('Failed to fetch privacy policy');
        }
        const content = await response.text();
        setMarkdownContent(content);
      } catch (error) {
        console.error('Error loading privacy policy:', error);
        setMarkdownContent('# Privacy Policy\n\nUnable to load privacy policy content. Please contact us at contact@mycelo.io for more information.');
      } finally {
        setLoading(false);
      }
    };

    loadMarkdownContent();
  }, []);

  if (loading) {
    return (
      <div className="policy-page">
        <div className="policy-content">
          <p>Loading privacy policy...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="policy-page">
      <div className="policy-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
